// from docs - https://docs.amplify.aws/gen1/javascript/build-a-backend/auth/auth-migration-guide/#authsignin
export const isTruthyString = (value: any) => {
  return value && typeof value.toLowerCase === 'function' && value.toLowerCase() === 'true'
}

export const USER_ORG_ID_KEY = 'UserOrgId'
export const OPTIV_STAGING_ORG_ID = 'dbc60a78-318b-572c-a0fd-dd6eef77eeb2'

export const setStoredOrgId = (orgId: string) => {
  try {
    window.localStorage.setItem(USER_ORG_ID_KEY, orgId)
  } catch (e) {
    console.warn('Failed to store org ID', e)
  }
}

export const getStoredOrgId = (): string | null => {
  try {
    return window.localStorage.getItem(USER_ORG_ID_KEY)
  } catch (e) {
    return null
  }
}
